/*
 * ELLIPAL 行情数据层 —— crypto-converter 与 crypto-market 两个 section 共用。
 *
 * 全页只发一次请求：扫描 [data-cg-ids] 收集所有 CoinGecko id，合并成一次
 * /coins/markets 调用（返回值同时含转换器要的价格和行情卡要的 7 项指标）。
 *
 * ponytail: 直连 CoinGecko 免费接口 + sessionStorage 60s 缓存。限流/被封的话
 * 只需把 ENDPOINT 换成自家代理（App Proxy / Worker，服务端缓存 + API key），
 * 返回结构保持一致，两个 section 一行都不用改。
 */
(function () {
  if (window.__ellipalCryptoFeed) return;
  window.__ellipalCryptoFeed = true;

  var ENDPOINT = 'https://api.coingecko.com/api/v3/coins/markets';
  var TTL = 60000;

  /* ---------- 工具 ---------- */

  function trimZeros(s) {
    return s.indexOf('.') === -1 ? s : s.replace(/0+$/, '').replace(/\.$/, '');
  }

  function fmtAmount(n) {
    if (!isFinite(n) || n <= 0) return '';
    var d = n >= 1000 ? 2 : n >= 1 ? 6 : 8;
    return trimZeros(n.toFixed(d));
  }

  function fmtPrice(n) {
    if (n == null) return null;
    return '$' + n.toLocaleString(undefined, { maximumFractionDigits: n < 10 ? 4 : 2 });
  }

  function fmtCompactUsd(n) {
    if (n == null) return null;
    if (n >= 1e12) return '$' + (n / 1e12).toFixed(2) + 'T';
    if (n >= 1e9) return '$' + (n / 1e9).toFixed(2) + 'B';
    if (n >= 1e6) return '$' + (n / 1e6).toFixed(2) + 'M';
    return '$' + n.toLocaleString();
  }

  function fmtSupply(n, symbol) {
    if (n == null) return null;
    var v = n >= 1e9 ? (n / 1e9).toFixed(2) + 'B'
      : n >= 1e6 ? (n / 1e6).toFixed(2) + 'M'
      : Math.round(n).toLocaleString();
    return v + ' ' + symbol;
  }

  function setText(root, key, value) {
    var el = root.querySelector('[data-mkt="' + key + '"]');
    if (el && value != null) el.textContent = value;
  }

  /* ---------- 取数（一次请求 + 会话内缓存） ---------- */

  function cacheGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var box = JSON.parse(raw);
      return Date.now() - box.t < TTL ? box.d : null;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data }));
    } catch (e) {
      /* 隐私模式 / 配额满：不缓存即可，不影响功能 */
    }
  }

  function collectIds() {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-cg-ids]'), function (el) {
      el.getAttribute('data-cg-ids').split(',').forEach(function (id) {
        id = id.trim();
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
    });
    return ids.sort();
  }

  function fetchMarkets(ids) {
    var key = 'ell:cg:' + ids.join(',');
    var hit = cacheGet(key);
    if (hit) return Promise.resolve(hit);

    var url = ENDPOINT + '?vs_currency=usd&ids=' + encodeURIComponent(ids.join(',')) +
      '&sparkline=true&price_change_percentage=24h';

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('bad response ' + res.status);
        return res.json();
      })
      .then(function (list) {
        var map = {};
        list.forEach(function (c) { map[c.id] = c; });
        cacheSet(key, map);
        return map;
      });
  }

  /* ---------- 转换器 ---------- */

  function initConverter(root) {
    if (root.dataset.cvtReady === 'true') return;
    root.dataset.cvtReady = 'true';

    var coins;
    try {
      coins = JSON.parse(root.getAttribute('data-coins') || '{}');
    } catch (e) {
      return;
    }

    var state = {
      from: root.getAttribute('data-from'),
      to: root.getAttribute('data-to'),
      prices: null
    };
    var fromAmount = root.querySelector('[data-cvt="from-amount"]');
    var toAmount = root.querySelector('[data-cvt="to-amount"]');
    var statusEl = root.querySelector('[data-cvt="status"]');
    var rateEl = root.querySelector('[data-cvt="rate"]');
    var swapBtn = root.querySelector('[data-cvt="swap"]');
    var template = root.getAttribute('data-rate-template') || '1 [from] = [rate] [to]';

    function setStatus(mode, text) {
      if (!statusEl) return;
      statusEl.className = 'cvt-status is-' + mode;
      statusEl.textContent = text;
    }

    function rate() {
      if (!state.prices) return null;
      var f = state.prices[state.from];
      var t = state.prices[state.to];
      if (!f || !t) return null;
      return f / t;
    }

    function recalc(source) {
      var r = rate();
      if (r == null) return;

      if (source === 'to') {
        var back = parseFloat(toAmount.value);
        fromAmount.value = isNaN(back) || back < 0 ? '' : fmtAmount(back / r);
      } else {
        var amt = parseFloat(fromAmount.value);
        toAmount.value = isNaN(amt) || amt < 0 ? '' : fmtAmount(amt * r);
      }

      if (rateEl) {
        rateEl.innerHTML = template
          .replace('[from]', state.from)
          .replace('[to]', state.to)
          .replace('[rate]', '<b>' + fmtAmount(r) + '</b>');
      }
    }

    function paintSide(side, symbol) {
      var meta = coins[symbol] || {};
      var label = root.querySelector('[data-cvt="' + side + '-symbol"]');
      var dot = root.querySelector('[data-cvt="' + side + '-dot"]');
      if (label) label.textContent = symbol;
      if (!dot) return;

      dot.textContent = '';
      if (meta.img) {
        // 有真实图标：清掉色块底，塞一张图（用 DOM API 建，不拼 innerHTML）
        dot.className = 'cvt-dot cvt-dot--img';
        dot.style.background = '';
        dot.style.color = '';
        var img = document.createElement('img');
        img.src = meta.img;
        img.alt = symbol;
        img.width = 48;
        img.height = 48;
        img.loading = 'lazy';
        dot.appendChild(img);
      } else {
        dot.className = 'cvt-dot';
        dot.textContent = meta.glyph || symbol.charAt(0);
        dot.style.background = meta.color || '';
        dot.style.color = meta.text || '';
      }
    }

    if (fromAmount) fromAmount.addEventListener('input', function () { recalc('from'); });
    if (toAmount) toAmount.addEventListener('input', function () { recalc('to'); });

    function swapSides() {
      var tmp = state.from;
      state.from = state.to;
      state.to = tmp;
      paintSide('from', state.from);
      paintSide('to', state.to);
    }

    if (swapBtn) {
      swapBtn.addEventListener('click', function () {
        swapSides();
        recalc('from');
      });
    }

    /* ---------- 选币弹窗 ---------- */

    var modal = root.querySelector('[data-cvt="modal"]');
    if (modal) {
      var search = modal.querySelector('[data-cvt="search"]');
      var empty = modal.querySelector('[data-cvt="empty"]');
      var items = modal.querySelectorAll('[data-cvt="currency"]');
      var closeBtn = modal.querySelector('[data-cvt="modal-close"]');
      var triggers = {
        from: root.querySelector('[data-cvt="from-picker"]'),
        to: root.querySelector('[data-cvt="to-picker"]')
      };
      var openSide = null;

      function filterList(q) {
        q = (q || '').trim().toLowerCase();
        var shown = 0;
        Array.prototype.forEach.call(items, function (item) {
          var hit = !q ||
            item.getAttribute('data-symbol').toLowerCase().indexOf(q) !== -1 ||
            (item.getAttribute('data-name') || '').toLowerCase().indexOf(q) !== -1;
          item.style.display = hit ? '' : 'none';
          if (hit) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      }

      function markCurrent() {
        Array.prototype.forEach.call(items, function (item) {
          var isCurrent = openSide && item.getAttribute('data-symbol') === state[openSide];
          if (isCurrent) {
            item.className = 'cvt-cur is-current';
          } else {
            item.className = 'cvt-cur';
          }
        });
      }

      function openPicker(side) {
        openSide = side;
        if (search) search.value = '';
        filterList('');
        markCurrent();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        if (triggers[side]) triggers[side].setAttribute('aria-expanded', 'true');
        if (search) search.focus();
      }

      function closePicker() {
        var side = openSide;
        openSide = null;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        if (side && triggers[side]) {
          triggers[side].setAttribute('aria-expanded', 'false');
          triggers[side].focus();
        }
      }

      function pick(symbol) {
        var other = openSide === 'from' ? 'to' : 'from';
        if (symbol === state[other]) {
          // 选到了对侧的币 —— 直接对调两边，而不是让两边显示同一个币
          swapSides();
        } else {
          state[openSide] = symbol;
          paintSide(openSide, symbol);
        }
        closePicker();
        if (state.prices && rate() == null) {
          root.__fail();
        } else {
          recalc('from');
        }
      }

      Object.keys(triggers).forEach(function (side) {
        if (triggers[side]) {
          triggers[side].addEventListener('click', function () { openPicker(side); });
        }
      });

      Array.prototype.forEach.call(items, function (item) {
        item.addEventListener('click', function () { pick(item.getAttribute('data-symbol')); });
      });

      if (closeBtn) closeBtn.addEventListener('click', closePicker);
      if (search) search.addEventListener('input', function () { filterList(search.value); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closePicker(); });
      document.addEventListener('keydown', function (e) {
        if (openSide && (e.key === 'Escape' || e.key === 'Esc')) closePicker();
      });
    }

    root.__apply = function (map) {
      var prices = {};
      Object.keys(coins).forEach(function (sym) {
        var coin = map[coins[sym].id];
        if (coin) prices[sym] = coin.current_price;
      });
      state.prices = prices;
      if (rate() == null) {
        root.__fail();
        return;
      }
      setStatus('live', (root.getAttribute('data-status-live') || 'live') + ' · ' + new Date().toLocaleTimeString());
      recalc('from');
    };

    root.__fail = function () {
      setStatus('error', root.getAttribute('data-status-error') || 'rate unavailable');
    };
  }

  /* ---------- 行情卡 ---------- */

  function drawSparkline(el, prices, positive) {
    if (!el || !prices || prices.length < 2) return;
    var w = 240, h = 44, pad = 3;
    var min = Math.min.apply(null, prices);
    var max = Math.max.apply(null, prices);
    var range = (max - min) || 1;
    var step = (w - pad * 2) / (prices.length - 1);
    el.setAttribute('points', prices.map(function (p, i) {
      var x = pad + i * step;
      var y = h - pad - ((p - min) / range) * (h - pad * 2);
      return x.toFixed(1) + ',' + y.toFixed(1);
    }).join(' '));
    el.setAttribute('stroke', positive ? 'var(--hp-green)' : '#ff8a8a');
  }

  function fillCard(card, coin) {
    var symbol = card.getAttribute('data-symbol') || '';
    setText(card, 'price', fmtPrice(coin.current_price));
    setText(card, 'mcap', fmtCompactUsd(coin.market_cap));
    setText(card, 'rank', coin.market_cap_rank ? '#' + coin.market_cap_rank : null);
    setText(card, 'vol', fmtCompactUsd(coin.total_volume));
    setText(card, 'supply', fmtSupply(coin.circulating_supply, symbol));

    var change = coin.price_change_percentage_24h;
    var changeEl = card.querySelector('[data-mkt="change"]');
    if (changeEl && change != null) {
      changeEl.textContent = (change >= 0 ? '+' : '') + change.toFixed(2) + '%';
      changeEl.className = 'cmk-change ' + (change >= 0 ? 'is-up' : 'is-down');
    }

    var updatedEl = card.querySelector('[data-mkt="updated"]');
    if (updatedEl && coin.last_updated) {
      updatedEl.textContent = (updatedEl.getAttribute('data-prefix') || 'Updated') + ' ' +
        new Date(coin.last_updated).toLocaleTimeString();
    }

    if (coin.sparkline_in_7d && coin.sparkline_in_7d.price) {
      drawSparkline(
        card.querySelector('[data-mkt="spark"]'),
        coin.sparkline_in_7d.price,
        change == null || change >= 0
      );
    }
  }

  function failCard(card) {
    var updatedEl = card.querySelector('[data-mkt="updated"]');
    if (updatedEl) updatedEl.textContent = updatedEl.getAttribute('data-error') || 'Market data unavailable';
  }

  /* ---------- 启动 ---------- */

  function run() {
    var converters = document.querySelectorAll('[data-cvt-root]');
    var cards = document.querySelectorAll('[data-mkt-card]');
    if (!converters.length && !cards.length) return;

    Array.prototype.forEach.call(converters, initConverter);

    var ids = collectIds();
    if (!ids.length) return;

    fetchMarkets(ids).then(function (map) {
      Array.prototype.forEach.call(converters, function (root) {
        if (root.__apply) root.__apply(map);
      });
      Array.prototype.forEach.call(cards, function (card) {
        var coin = map[card.getAttribute('data-cg-id')];
        if (coin) { fillCard(card, coin); } else { failCard(card); }
      });
    })['catch'](function () {
      Array.prototype.forEach.call(converters, function (root) {
        if (root.__fail) root.__fail();
      });
      Array.prototype.forEach.call(cards, failCard);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // 主题编辑器里增删 section 后重新填充
  document.addEventListener('shopify:section:load', run);
})();
